import React from 'react';
import { Lottie } from '@mentimeter/motion';
import { alpha } from '@mentimeter/ragnar-colors';
import { useTranslations } from 'next-intl';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

export const GroupingLoader = () => {
  const translate = useTranslations('presenting.legacy');

  return (
    <Box alignItems="center" justifyContent="center" width="100%" height="100%">
      <Box
        alignItems="center"
        borderRadius="64px"
        p={5}
        extend={({ theme }) => ({
          background: alpha(theme.colors.neutralWeakest, 0.75),
        })}
      >
        <Box width="400px">
          <Lottie
            path="https://static.mentimeter.com/static/motion/GroupingLoading.json"
            autoplay
            loop
          />
        </Box>
        <Text fontSize={5} color="text" mt={4}>
          {translate('open.loading_groups')}
        </Text>
      </Box>
    </Box>
  );
};
